<template>
    <div></div>
</template>

<script>
import { ssoLogin } from "../../../resources/api/sso.js";

export default {
    name: "SSOLogin",

    async created() {
        const tempCode = this.$route.query.tempCode;
        const redirectUrl = this.$route.query.redirectUrl;

        try {
            if (tempCode) {
                const res = await ssoLogin({ tempCode: tempCode });
                this.fnSetAuthInfo(res);
            }
        } catch (error) {
            // 전파 실패 무시
            console.error('SSO 로그인 실패:', error);
        }

        // 요청한 시스템으로 복귀
        window.location.href = redirectUrl || this.$filters.ctxPath('/');
    },

    methods: {
        // 로그인 응답을 store 에 반영
        fnSetAuthInfo(res) {
            const loginMode = res.headers['loginmode']; // J, S
            const policyMode = res.headers['policymode']; // Y, N

            this.$store.commit('setLoginMode', loginMode || 'J');
            this.$store.commit('setPolicyMode', policyMode || 'Y');

            if (loginMode === 'S') {
                // 세션 모드 - 응답 바디의 회원 정보 사용
                const userInfo = res.data;
                const roles = (userInfo.roles || []).map(r => ({ authority: r.authrtCd }));

                this.$store.commit('setAuthorization', null);
                this.$store.commit('setMbrId', userInfo.mbrId);
                this.$store.commit('setMbrNm', userInfo.mbrNm);
                this.$store.commit('setRoles', roles);
            } else {
                // JWT 모드 - Authorization 헤더의 토큰 사용
                const token = res.headers.authorization;
                const userInfo = this.fnParseJwt(token);
                if (userInfo == null) {
                    return;
                }

                this.$store.commit('setAuthorization', token);
                this.$store.commit('setMbrId', userInfo.mbrId);
                this.$store.commit('setMbrNm', userInfo.mbrNm);
                this.$store.commit('setRoles', userInfo.roles);
            }
        },

        // JWT 토큰 파싱
        fnParseJwt(token) {
            try {
                const base64String = token.split('.')[1];
                const base64 = base64String.replace(/-/g, '+').replace(/_/g, '/');
                const jsonPayload = decodeURIComponent(
                    atob(base64)
                        .split('')
                        .map(c => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
                        .join(''),
                );
                return JSON.parse(jsonPayload);
            } catch (e) {
                console.error('JWT 파싱 실패:', e);
                return null;
            }
        },
    },
};
</script>

<style scoped></style>
